const testimonials = [
  {
    name: "Marie Dubois",
    location: "Lyon",
    rating: 5,
    text: "Service exceptionnel ! Mon album de mariage est arrivé rapidement et la qualité d'impression est parfaite. Je recommande vivement Wememberz.",
    avatar: "MD"
  },
  {
    name: "Pierre Martin", 
    location: "Paris",
    rating: 5,
    text: "Interface très simple à utiliser. J'ai pu créer l'album de vacances de toute la famille en moins d'une heure. Résultat magnifique !",
    avatar: "PM"
  },
  {
    name: "Sophie Laurent",
    location: "Marseille", 
    rating: 5,
    text: "Excellent rapport qualité-prix. Les finitions sont soignées et l'engagement écologique de l'entreprise me plaît beaucoup.",
    avatar: "SL"
  }
]

export default function TestimonialsSection() {
  return (
    <section className="py-12 lg:py-16 bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16 lg:mb-24">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground max-w-4xl mx-auto leading-tight">
            Ce que disent nos{" "}
            <span className="text-gradient">clients</span>
          </h2>
          <div className="flex items-center justify-center space-x-1">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="w-5 h-5 text-yellow-400">⭐</div>
            ))}
            <span className="ml-3 text-muted-foreground">4.8/5 basé sur +1000 avis</span>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-card/50 backdrop-blur-sm rounded-2xl p-8 shadow-card hover:shadow-elegant transition-smooth group border border-border/30"
            >
              {/* Stars */}
              <div className="flex space-x-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <div key={i} className="w-4 h-4 text-yellow-400">⭐</div>
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-muted-foreground leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-hero-gradient rounded-full flex items-center justify-center shadow-card">
                  <span className="text-white font-semibold text-sm">
                    {testimonial.avatar}
                  </span>
                </div>
                <div>
                  <div className="font-semibold text-foreground">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Stats */}
        <div className="grid grid-cols-3 gap-8 mt-16 pt-16 border-t border-border/50">
          <div className="text-center">
            <div className="text-2xl lg:text-3xl font-display font-bold mb-2" style={{ color: 'hsl(var(--stats-orange))' }}>
              15k+
            </div>
            <div className="text-sm text-muted-foreground">
              Albums créés
            </div>
          </div>
          <div className="text-center">
            <div className="text-2xl lg:text-3xl font-display font-bold mb-2" style={{ color: 'hsl(var(--stats-orange))' }}>
              4.8/5
            </div>
            <div className="text-sm text-muted-foreground">
              Note moyenne
            </div>
          </div>
          <div className="text-center">
            <div className="text-2xl lg:text-3xl font-display font-bold mb-2" style={{ color: 'hsl(var(--stats-orange))' }}>
              0€
            </div>
            <div className="text-sm text-muted-foreground">
              Livraison offerte dès 50€ d'achat
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}